var map = {
	"./1-1 Meetings.jpg": 4182,
	"./After conference party - U-Fleku.jpg": 4756,
	"./Gala Banquet at Troja Palace.jpg": 7478,
	"./Group Photos.jpg": 1113,
	"./Lunch.jpg": 572,
	"./Opening Ceremony.jpg": 2262,
	"./Registration.jpg": 4470,
	"./Vintage car journey to the Troja Palace.jpg": 7704,
	"./Welcome Cocktail.jpg": 3231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8447;